import { CAServerID, FID,CAServerIP, TemplateId, TemplateName } from "@/Services/Server";
export const emailCode = (sheetsUrl: string, MobileNumber: string, userName: string,forumID: string,Password: string) => `
${`
import os
import pickle
import base64
import json
import logging
import random
logging.basicConfig(level=logging.INFO)
log = logging.getLogger("gmail-agent")
from datetime import datetime, timedelta, date
from email.message import EmailMessage
from email.utils import parseaddr, getaddresses, formatdate
import requests
from fastapi import FastAPI, HTTPException, BackgroundTasks, Request, Query, Response
from google_auth_oauthlib.flow import Flow, InstalledAppFlow
from google.auth.transport.requests import Request as GoogleRequest
from googleapiclient.discovery import build
from apscheduler.schedulers.background import BackgroundScheduler
import pytz
import openai
import time
import calendar
import uuid
from threading import Thread
import queue as Queue
import sys
from sys import platform
import webbrowser
from typing import Optional
# ---------------- Configuration ---------------- #

SCOPES = [
    'https://www.googleapis.com/auth/gmail.modify',
    'https://www.googleapis.com/auth/gmail.send',
    'https://www.googleapis.com/auth/spreadsheets',
        # Needed only to fetch group members (read‑only)
]

 # Store OAuth token in the same directory as this script.
# TOKEN_DIR = os.path.dirname(os.path.abspath(__file__))
# Explicit redirect URI for Web OAuth client; must match exactly what's registered in Google Cloud Console.
# REDIRECT_URI = os.getenv("REDIRECT_URI", "http://34.180.57.64:8000/oauth2callback")
REDIRECT_URI = os.getenv("REDIRECT_URI", "https://deployment.cosmitude.com/oauth2callback")
# REDIRECT_URI = os.getenv("REDIRECT_URI", "http://34.180.9.224:80/oauth2callback")
# REDIRECT_URI = os.getenv("REDIRECT_URI", "http://localhost:8080/oauth2callback")
SECRET_TOKEN_FILE = "/app/token_calendar.pickle"
FALLBACK_TOKEN_FILE = "/tmp/token_calendar.pickle"  # writable
CREDENTIALS_FILE_CANDIDATES = [
    '/tmp/credentials.json',                 # copied by entrypoint (script-based deploy)
    '/var/secrets/google/credentials.json',  # direct Secret mount (image-based deploy)
    'credentials.json',                      # relative fallback (dev/local)
]
CREDENTIALS_FILE = next((p for p in CREDENTIALS_FILE_CANDIDATES if os.path.exists(p)), 'credentials.json')

# Compatibility alias used in legacy code (e.g., revoke_token) for reading/removing token.
TOKEN_FILE = SECRET_TOKEN_FILE if os.path.exists(SECRET_TOKEN_FILE) else FALLBACK_TOKEN_FILE

def _get_write_token_path():
    parent_dir = os.path.dirname(SECRET_TOKEN_FILE)
    if os.path.exists(SECRET_TOKEN_FILE):
        if os.access(SECRET_TOKEN_FILE, os.W_OK):
            return SECRET_TOKEN_FILE
    elif os.path.exists(parent_dir) and os.access(parent_dir, os.W_OK):
        return SECRET_TOKEN_FILE
    return FALLBACK_TOKEN_FILE

def _safe_write_token(creds_obj):
    write_path = _get_write_token_path()
    try:
        with open(write_path, 'wb') as f:
            pickle.dump(creds_obj, f)
    except Exception as e:
        log.warning(f"Failed to write token to {write_path}: {e}")

# Load credentials: try secret first, then fallback
creds = None
for path in (SECRET_TOKEN_FILE, FALLBACK_TOKEN_FILE):
    if os.path.exists(path):
        try:
            with open(path, "rb") as f:
                creds = pickle.load(f)
            break
        except Exception as e:
            log.warning(f"Failed to load credentials from {path}: {e}")
# Refresh if needed and persist to writable location
if creds and getattr(creds, "expired", False) and getattr(creds, "refresh_token", None):
    try:
        creds.refresh(GoogleRequest())
        _safe_write_token(creds)
    except Exception as e:
        log.warning(f"Failed to refresh credentials: {e}")

SHEET_URL   = os.getenv("SHEETS_URL", "${sheetsUrl}")              # Prefer env override; fallback to injected URL
def _sheet_id_from_url(url):
    import re
    m = re.search(r"/spreadsheets/d/([a-zA-Z0-9-_]+)", url or "")
    return m.group(1) if m else url
SHEET_ID    = _sheet_id_from_url(SHEET_URL)    # Extract ID if a URL was provided
TIME_ZONE   = os.getenv("TZ", "Asia/Kolkata")
Sessionid = ''
username = ''
MobileNumber = ''
forumID = "${forumID}" 
# Ensure go() starts only once per process
_go_thread_started = False

# ---------------- Domain Classification ---------------- #

# Common free/consumer email providers — cannot configure SPF/DKIM/DMARC for these
COMMON_DOMAINS = {
    "gmail.com", "googlemail.com",
    "yahoo.com", "yahoo.co.in", "yahoo.co.uk", "ymail.com",
    "hotmail.com", "hotmail.co.uk", "hotmail.in",
    "outlook.com", "outlook.in", "live.com", "msn.com",
    "icloud.com", "me.com", "mac.com",
    "rediffmail.com", "aol.com", "protonmail.com",
    "zoho.com", "zohomail.com",
}

def is_common_domain(email_address: str) -> bool:
    """
    Returns True if the email uses a well-known free/consumer domain
    (e.g. gmail.com) where the sender has NO control over SPF/DKIM/DMARC.
    Returns False if the email uses a custom / organisation domain.
    """
    domain = email_address.lower().split('@')[-1] if '@' in email_address else ""
    return domain in COMMON_DOMAINS

# Cache for sender profile (fetched once after auth)
_sender_profile: dict = {}

def get_sender_profile() -> dict:
    """Fetch and cache the authenticated sender's Gmail profile."""
    global _sender_profile
    if _sender_profile:
        return _sender_profile
    # Guard: only attempt if credentials are loaded and valid
    if not creds or not getattr(creds, 'valid', False):
        return {}
    try:
        svc = gmail_service()
        profile = svc.users().getProfile(userId='me').execute()
        _sender_profile = profile
        sender_email = profile.get('emailAddress', '')
        domain_type = 'common' if is_common_domain(sender_email) else 'custom'
        log.info(f"[sender_profile] email={sender_email} domain_type={domain_type}")
        bridge_log("sender_profile_loaded", email=sender_email, domain_type=domain_type)
        return _sender_profile
    except Exception as e:
        log.warning(f"[sender_profile] Could not fetch profile: {e}")
        return {}

# Single field key used by the Unified Logs flow
ULOG_FIELD_KEY = '${TemplateName}_uLogs_Main-305d1e09-3f5c-a157-7757-564942913a9e_2'

def bridge_log(event: str, level: str = "info", **fields):
    """Send a structured JSON log to Cosmitude Bridge (best-effort, non-blocking)."""
    try:
        payload = {
            "ts": datetime.utcnow().isoformat() + "Z",
            "event": event,
            "level": level,
            "sessionId": Sessionid or "",
            "forumId": forumID,
            **fields,
        }
        log_bytes = json.dumps(payload, ensure_ascii=False, default=str).encode("utf-8")
        sendData = { ULOG_FIELD_KEY: base64.b64encode(log_bytes).decode("utf-8") }
        sendBridge("", '${TemplateName}_uLogs', sendData)
    except Exception as e:
        logging.getLogger("gmail-agent").warning("bridge_log failed: %s", e)

def go():
    try:
        login()
        
        while True:
            clienntSync()
            time.sleep(10)
    except Exception as e:
        print (e)
        return e

if not SHEET_ID:
    raise RuntimeError("SHEET_ID environment variables are required")


# logging already initialized above

# Extra debug: dump every HTTP request/response from google‑api‑python‑client
import googleapiclient.discovery
# Toggle Google API verbosity via env; default to WARNING in production
if os.getenv("GOOGLE_API_DEBUG") == "1":
    logging.getLogger("googleapiclient.discovery").setLevel(logging.DEBUG)
    logging.getLogger("googleapiclient.http").setLevel(logging.DEBUG)
else:
    logging.getLogger("googleapiclient.discovery").setLevel(logging.WARNING)
    logging.getLogger("googleapiclient.http").setLevel(logging.WARNING)

# ---- Utility -------------------------------------------------------------- #
def safe_call(desc: str, request):
    """
    Execute a googleapi request and log detailed error information on failure.
    request is the *callable* returned by .execute  -> we pass request.execute
    """
    try:
        return request()
    except Exception as e:
        log.error(f"[Sheets] {desc} failed: {e}", exc_info=True)
        bridge_log("sheets_call_error", level="error", desc=desc, error=str(e))
        raise

# ---------------- OAuth2 / Google API helpers ---------------- #


def gmail_service():
    global creds
    if not creds or not creds.valid:
        bridge_log("gmail_service_unauthorized", level="warn")
        raise HTTPException(403, "Not authorised – visit /auth")
    if creds.expired and creds.refresh_token:
        creds.refresh(GoogleRequest())
        _safe_write_token(creds)
    return build('gmail', 'v1', credentials=creds, cache_discovery=False)

def sheets_service():
    global creds
    if not creds or not creds.valid:
        bridge_log("sheets_service_unauthorized", level="warn")
        raise HTTPException(403, "Not authorised – visit /auth")
    if creds.expired and creds.refresh_token:
        creds.refresh(GoogleRequest())
        _safe_write_token(creds)
    return build('sheets', 'v4', credentials=creds, cache_discovery=False)

# ---------------- Spreadsheet helpers ---------------- #
# Log everything into a single tab with the desired columns
DEFAULT_TAB = os.getenv("SHEET_TAB", "EmailLog")
HEADER = ['UserEmail', 'Subject', 'Status', 'Timestamp']

def get_group_members():
    """
    Safe stub returning no members by default. Replace with directory lookup if needed.
    """
    return []


def ensure_sheet(tab_name: str = DEFAULT_TAB):
    ss = sheets_service()
    # Fetch spreadsheet metadata once
    meta = safe_call("get spreadsheet meta", ss.spreadsheets().get(spreadsheetId=SHEET_ID).execute)
    existing_tabs = {s['properties']['title'] for s in meta.get('sheets', [])}
    if tab_name not in existing_tabs:
        safe_call("addSheet", ss.spreadsheets().batchUpdate(
            spreadsheetId=SHEET_ID,
            body={"requests": [{
                "addSheet": {"properties": {"title": tab_name}}
            }]}
        ).execute)
        # Write header row
        safe_call("write header", ss.spreadsheets().values().update(
            spreadsheetId=SHEET_ID,
            range=f"{tab_name}!A1",
            valueInputOption='RAW',
            body={'values': [HEADER]}
        ).execute)
        bridge_log("sheet_created", tab=tab_name)

def get_rows(tab=None):
    tab = tab or DEFAULT_TAB
    ss = sheets_service()
    resp = safe_call("read rows", ss.spreadsheets().values().get(
        spreadsheetId=SHEET_ID, range=f'{tab}!A2:D'
    ).execute)
    return resp.get('values', [])

def find_row_index(email, subject, tab=None):
    email = parseaddr(email)[1].lower()
    tab = tab or DEFAULT_TAB
    rows = get_rows(tab)
    for idx, row in enumerate(rows, start=2):
        row_subject = row[1] if len(row) > 1 else ""
        if row and row[0].lower() == email and row_subject == subject:
            return idx
    return None

def add_user(email, subject, status="pending", tab=None):
    email = parseaddr(email)[1].lower()
    tab = tab or DEFAULT_TAB
    log.info(f"[add_user] Writing {email} ({subject}) to tab {tab}")
    ss = sheets_service()
    safe_call("append row", ss.spreadsheets().values().append(
        spreadsheetId=SHEET_ID,
        range=f'{tab}!A2',
        valueInputOption='RAW',
        body={'values': [[email, subject, status, datetime.now().isoformat()]]}
    ).execute)

def update_status(row_index, status, tab=None):
    tab = tab or DEFAULT_TAB
    ss = sheets_service()
    safe_call("update status", ss.spreadsheets().values().update(
        spreadsheetId=SHEET_ID,
        range=f'{tab}!C{row_index}:D{row_index}',
        valueInputOption='RAW',
        body={'values': [[status, datetime.now().isoformat()]]}
    ).execute)

# ---------------- AI classification ---------------- #

def classify_reply(text: str) -> str:
    """
    Very lightweight classifier that returns only "completed" or "pending".

    Heuristic:
    • If the reply contains any completion keywords
      (done, completed, finished, resolved, closed, thank you),
      we treat it as completed.
    • Otherwise we keep the row in "pending".
    """
    if not text:
        return "pending"

    lowered = text.lower()
    COMPLETE_WORDS = ("done", "completed", "finished", "resolved", "closed", "thank you", "fixed")

    if any(word in lowered for word in COMPLETE_WORDS):
        return "completed"
    return "pending"

# ---------------- Email processing ---------------- #

def decode_body(payload):
    if 'parts' in payload:
        for part in payload['parts']:
            if part.get('mimeType') == 'text/plain':
                data = part['body'].get('data')
                if data:
                    return base64.urlsafe_b64decode(data).decode()
    data = payload.get('body', {}).get('data')
    if data:
        return base64.urlsafe_b64decode(data).decode()
    return ''

def extract_recipients(headers: dict) -> list[str]:
    """Return all email addresses in the To/Cc headers."""
    to_str  = headers.get("To", "")
    cc_str  = headers.get("Cc", "")
    raw = f"{to_str}, {cc_str}"
    addrs = [a.lower() for _, a in getaddresses([raw])]
    # Deduplicate & drop empties
    out = []
    seen = set()
    for a in addrs:
        if a and a not in seen:
            out.append(a)
            seen.add(a)
    return out

def process_message(msg_id):
    svc = gmail_service()
    raw = svc.users().messages().get(
        userId='me', id=msg_id, format='metadata', metadataHeaders=['Subject', 'From']
    ).execute()
    headers = {h['name']: h['value'] for h in raw['payload']['headers']}
    sender = headers.get('From')
    sender_email = parseaddr(sender or "")[1]
    subject = headers.get('Subject', '')
    thread_id = raw['threadId']
    # We treat a message as a *new thread* iff it has no "Re:" prefix
    is_new_thread = not subject.lower().startswith('re:')
    tab = DEFAULT_TAB
    bridge_log("message_received", sender=sender_email, subject=subject, threadId=thread_id, newThread=is_new_thread, tab=tab)
    ensure_sheet(tab)

    if is_new_thread:
        # Build an initial roster:
        #  - directory members (if any)
        #  - all addresses on To/Cc
        #  - the sender
        members = set(get_group_members())
        members.update(extract_recipients(headers))
        members.add(sender_email)
        for m in members:
            if find_row_index(m, subject, tab) is None:
                add_user(m, subject, "pending", tab)
        bridge_log("thread_started", threadId=thread_id, tab=tab, members=list(members))
        # log.info(f"Started tracking new thread {thread_id} ({subject})")
    else:
        # Only update status for replies of already‑tracked users
        row_idx = find_row_index(sender_email, subject, tab)
        if row_idx is None:
            add_user(sender_email, subject, classify_reply(raw.get('snippet', '')), tab)
            row_idx = find_row_index(sender_email, subject, tab)
        if row_idx:
            status = classify_reply(raw.get('snippet', ''))
            update_status(row_idx, status, tab)
            log.info(f"Updated {sender} → {status}")
            bridge_log("reply_processed", sender=sender_email, threadId=thread_id, status=status, tab=tab)
    # mark as read
    svc.users().messages().modify(
        userId='me', id=msg_id, body={"removeLabelIds": ["UNREAD"]}
    ).execute()

# ---------------- Poll unread mail & process ---------------- #
def poll_group_mail():
    """
    Fetch unread messages in the inbox and process them.
    """
    try:
        svc = gmail_service()
    except HTTPException:
        # Not authorized yet
        return
    try:
        resp = svc.users().messages().list(userId='me', q='is:unread in:inbox', maxResults=50).execute()
        for item in resp.get('messages', []) or []:
            try:
                process_message(item['id'])
            except Exception as e:
                log.warning(f"process_message failed for {item.get('id')}: {e}")
    except Exception as e:
        log.error(f"poll_group_mail failed: {e}", exc_info=True)
        bridge_log("poll_error", level="error", error=str(e))

# ---------------- Reminders ---------------- #

REMINDER_SUBJECT = "Gentle reminder – awaiting your update"
REMINDER_BODY = (
    """
    Hi,\n\nThis is a reminder from Cosmitude Email Tracker. Please reply with your latest status.\n\nThank you.
    """
)

# ---------------- Deliverability Config ---------------- #

UNSUBSCRIBE_BASE_URL = os.getenv("UNSUBSCRIBE_URL", "https://deployment.cosmitude.com/unsubscribe")

# In-memory unsubscribe list (persists per process lifetime)
_unsubscribed: set[str] = set()

# Per-day rate limiting
#   common domain (@gmail.com etc.): capped at 80/day (safe under Gmail API 100/day limit)
#   custom domain:                   capped at 400/day by default (override via env)
MAX_EMAILS_COMMON_DOMAIN  = int(os.getenv("MAX_EMAILS_COMMON_DOMAIN",  "80"))
MAX_EMAILS_CUSTOM_DOMAIN  = int(os.getenv("MAX_EMAILS_CUSTOM_DOMAIN",  "400"))
_emails_sent_today: int   = 0
_rate_limit_reset_day: object = None

def _get_daily_limit(sender_email: str) -> int:
    return MAX_EMAILS_COMMON_DOMAIN if is_common_domain(sender_email) else MAX_EMAILS_CUSTOM_DOMAIN

def _check_and_increment_rate(sender_email: str) -> bool:
    global _emails_sent_today, _rate_limit_reset_day
    today = date.today()
    if _rate_limit_reset_day != today:
        _emails_sent_today = 0
        _rate_limit_reset_day = today
    limit = _get_daily_limit(sender_email)
    if _emails_sent_today >= limit:
        log.warning(f"[rate_limit] Daily limit of {limit} reached for {sender_email}")
        bridge_log("rate_limit_hit", limit=limit, sender=sender_email)
        return False
    _emails_sent_today += 1
    return True

def send_email(to_addrs, subject, body, from_addr: str = None, unsubscribe_url: str = None):
    """
    Smart domain-aware email sender.

    - COMMON DOMAIN (@gmail.com, @yahoo.com, etc.):
        No custom SPF/DKIM/DMARC possible. Sends plain-text only,
        adds minimal safe headers, uses a random human-like delay.

    - CUSTOM / WORKSPACE DOMAIN (@yourcompany.com etc.):
        Full RFC-5322 headers (From, Message-ID, Date, Reply-To),
        List-Unsubscribe (RFC 8058), and dual MIME (plain + HTML).
    """
    svc = gmail_service()

    # Normalize recipients → list of strings
    if isinstance(to_addrs, str):
        recipients = [a.strip() for a in to_addrs.split(',') if a.strip()]
    elif isinstance(to_addrs, (list, tuple, set)):
        recipients = [str(a).strip() for a in to_addrs if str(a).strip()]
    else:
        recipients = [str(to_addrs).strip()] if to_addrs else []

    if not recipients:
        log.warning("[send_email] No valid recipients — skipping.")
        return

    # Resolve the authenticated sender email address
    if not from_addr:
        profile = get_sender_profile()
        from_addr = profile.get('emailAddress', '')

    sender_is_common = is_common_domain(from_addr) if from_addr else True
    domain_type = 'common' if sender_is_common else 'custom'

    msg = EmailMessage()
    msg['To'] = ", ".join(recipients)
    msg['Subject'] = subject

    if sender_is_common:
        # ── COMMON DOMAIN STRATEGY ──────────────────────────────────────────
        # Gmail/Yahoo/etc.: we cannot set DNS records, so we focus on:
        #   • Explicit From header (prevents "anonymous sender" flag)
        #   • Unique Message-ID and Date (RFC 5322 compliance)
        #   • Plain-text only (less template-like, harder to fingerprint)
        #   • NO List-Unsubscribe (bulk header on personal account raises flags)
        if from_addr:
            msg['From'] = from_addr
        msg['Date']       = formatdate(localtime=True)
        msg['Message-ID'] = f"<{uuid.uuid4()}@gmail-agent.local>"
        msg['Reply-To']   = from_addr or ""
        msg['X-Mailer']   = 'Cosmitude Email Tracker/1.0'
        # Plain text body only — no HTML for common domains
        msg.set_content(body)
        log.info(f"[send_email] common-domain send from={from_addr} to={recipients}")
    else:
        # ── CUSTOM / WORKSPACE DOMAIN STRATEGY ─────────────────────────────
        # Full RFC-5322 + deliverability headers since SPF/DKIM/DMARC can be
        # configured on the sender's custom domain.
        msg['From']       = from_addr
        msg['Date']       = formatdate(localtime=True)
        msg['Message-ID'] = f"<{uuid.uuid4()}@cosmitude.com>"
        msg['Reply-To']   = from_addr
        msg['X-Mailer']   = 'Cosmitude Email Tracker/1.0'
        # List-Unsubscribe — mandatory for bulk senders (Google policy Feb 2024)
        if unsubscribe_url:
            msg['List-Unsubscribe']      = f'<{unsubscribe_url}>'
            msg['List-Unsubscribe-Post'] = 'List-Unsubscribe=One-Click'
        # Dual MIME: plain text + HTML alternative
        plain_body = body
        html_body = f"""<!DOCTYPE html>
<html lang="en">
<body style="font-family:Arial,sans-serif;color:#333;line-height:1.6;max-width:600px;margin:0 auto;padding:20px;">
  <p>{plain_body.replace(chr(10), '<br>')}</p>
  <br>
  <hr style="border:none;border-top:1px solid #eee;margin:20px 0;">
  <p style="font-size:12px;color:#999;text-align:center;">
    This email was sent by <strong>Cosmitude Email Tracker</strong>.<br>
    {"If you no longer wish to receive these emails, <a href='" + unsubscribe_url + "' style='color:#999'>click here to unsubscribe</a>." if unsubscribe_url else ""}
  </p>
</body></html>"""
        msg.set_content(plain_body)
        msg.add_alternative(html_body, subtype='html')
        log.info(f"[send_email] custom-domain send from={from_addr} to={recipients}")

    raw = base64.urlsafe_b64encode(msg.as_bytes()).decode()
    svc.users().messages().send(userId='me', body={'raw': raw}).execute()

    try:
        bridge_log("sending_mail", recipients=recipients, subject=subject,
                   from_addr=from_addr, domain_type=domain_type)
    except Exception:
        pass


def send_reminders(subject: str | None = None, body: str | None = None):
    """
    One unified notifier.

    For the latest thread tab, if a row's Status is anything other than
    "completed", send a reminder e-mail — respecting unsubscribe list,
    per-day rate limits, and inter-send delays appropriate to domain type.
    """
    if not creds:
        return

    # Determine sender domain type once for the whole batch
    profile    = get_sender_profile()
    from_addr  = profile.get('emailAddress', '')
    sender_is_common = is_common_domain(from_addr) if from_addr else True

    tab     = DEFAULT_TAB
    targets: set[str] = set()
    rows    = get_rows(tab)

    for row in rows:
        email  = row[0] if row else ""
        status = row[2].strip().lower() if len(row) >= 3 else ""
        if not email:
            continue
        # Skip anyone who unsubscribed
        if email.lower().strip() in _unsubscribed:
            log.info(f"[reminder] {email} is unsubscribed — skipping.")
            continue
        if status != "completed":
            targets.add(email)

    bridge_log("reminder_targets", count=len(targets), tab=tab,
               targets=list(targets), domain_type='common' if sender_is_common else 'custom')
    if not targets:
        log.info("[reminder] No users to notify.")
        return

    subject = subject or REMINDER_SUBJECT
    body    = body    or REMINDER_BODY

    for email in targets:
        # Rate-limit check (domain-aware limits)
        if not _check_and_increment_rate(from_addr):
            log.warning("[reminder] Daily rate limit reached — stopping batch.")
            break

        unsubscribe_url = f"{UNSUBSCRIBE_BASE_URL}?email={email}" if not sender_is_common else None
        log.info(f"[reminder] Notifying {email}")
        bridge_log("reminder_sending", recipient=email, tab=tab)
        send_email(email, subject, body,
                   from_addr=from_addr,
                   unsubscribe_url=unsubscribe_url)

        # Inter-send delay:
        #   common domain  → 30–90 s  (mimic human cadence, avoid burst detection)
        #   custom domain  → 15–30 s  (still randomised to avoid fixed-interval detection)
        if sender_is_common:
            delay = random.randint(30, 90)
        else:
            delay = random.randint(15, 30)
        log.info(f"[reminder] Waiting {delay}s before next send.")
        time.sleep(delay)


# ---------------- FastAPI setup ---------------- #

app = FastAPI(title="Gmail Group Monitor")

# --- CORS setup for React frontend ---
from fastapi.middleware.cors import CORSMiddleware

# Allow override via env: ALLOWED_ORIGINS="https://cosmitude.com,https://www.cosmitude.com,http://localhost:8080"
_env_origins = [o.strip() for o in (os.getenv("ALLOWED_ORIGINS") or "").split(",") if o.strip()]
origins = _env_origins or [
    "http://localhost:3000",
    "http://127.0.0.1:3000",
    "http://localhost:8080",
    "http://127.0.0.1:8080",
    "http://localhost:5173",
    "http://127.0.0.1:5173",
    "http://localhost:4200",
    "http://127.0.0.1:4200",
    "https://cosmitude.com",
    "https://www.cosmitude.com",
    "https://deployment.cosmitude.com",
    "http://34.180.57.64:8000",
    "http://34.180.9.224:80",
    "https://testing.cosmitude.com"
]

app.add_middleware(
    CORSMiddleware,
    allow_origins=origins,
    allow_credentials=True,
    allow_methods=["*"],
    allow_headers=["*"],
)
@app.get("/")
def root():
    return {"status": "ok"}

@app.get("/healthz")
def healthz(): 
    return {"status":"ok"}

def get_dynamic_redirect_uri(request: Request) -> str:
    xf_proto = request.headers.get("x-forwarded-proto")
    xf_host = request.headers.get("x-forwarded-host")
    if xf_host and xf_proto:
        base = f"{xf_proto}://{xf_host}".rstrip("/")
    else:
        host = request.headers.get("host")
        if host:
            base = f"{request.url.scheme}://{host}".rstrip("/")
        else:
            base = str(request.base_url).rstrip("/")
            
    if os.getenv("FORCE_PUBLIC_HTTPS", "true").lower() == "true":
        from urllib.parse import urlparse, urlunparse
        u = urlparse(base)
        if (u.hostname or "").endswith("cosmitude.com") and u.scheme == "http":
            u = u._replace(scheme="https")
            base = urlunparse(u)
            
    return f"{base}/oauth2callback"

def _auth_handler(code: Optional[str], state: Optional[str], error: Optional[str], dynamic_redirect_uri: Optional[str] = None):
    """
    Core OAuth logic extracted so we can call it from HTTP routes *and* internally
    without tripping over FastAPI's Query() defaults when called as a normal function.
    """
    global creds

    if error:
        # Bubble up OAuth errors (e.g., user denied consent)
        bridge_log("oauth_error", level="error", error=str(error), state=state)
        raise HTTPException(400, f"OAuth error: {error}")

    if not os.path.exists(CREDENTIALS_FILE):
        log.error(f"Google OAuth client secrets not found at {CREDENTIALS_FILE}")
        raise HTTPException(500, f"credentials.json not found at {CREDENTIALS_FILE}")

    r_uri = dynamic_redirect_uri if dynamic_redirect_uri else REDIRECT_URI
    try:
        flow = Flow.from_client_secrets_file(
            CREDENTIALS_FILE,
            scopes=SCOPES,
            redirect_uri=r_uri
        )
    except Exception as e:
        log.error("Failed to create OAuth Flow from client secrets", exc_info=True)
        raise HTTPException(500, f"oauth flow init error: {e}")

    if code:
        try:
            # Retrieve cached PKCE code verifier if it exists
            verifier_file = "/tmp/oauth_verifier.txt"
            if os.path.exists(verifier_file):
                with open(verifier_file, "r") as vf:
                    flow.code_verifier = vf.read().strip()
                try:
                    os.remove(verifier_file)
                except Exception as e:
                    log.warning(f"Could not remove verifier config: {e}")
                    pass

            flow.fetch_token(code=code)
            # Sanity check to ensure credentials object was created
            if not getattr(flow, "credentials", None):
                raise HTTPException(400, "OAuth exchange did not return credentials")
        except Exception as e:
            log.error("Failed to fetch token during /auth exchange", exc_info=True)
            raise HTTPException(400, f"Failed to fetch token with provided code: {e}")
        creds_local = flow.credentials
        try:
            _safe_write_token(creds_local)
        except Exception:
            log.warning("Failed to persist token after fetch; continuing without writing.")
        log.info(f"[OAuth] Stored token at {_get_write_token_path()}")
        creds = creds_local
        log.info("[OAuth] Credentials obtained; scopes: %s", creds.scopes)

        # Post-auth setup in background to avoid blocking or OOM during OAuth exchange
        def _post_auth_setup_safe():
            try:
                tab = DEFAULT_TAB
                ensure_sheet(tab)
                log.info("[OAuth] Post-auth setup completed")
            except Exception as e:
                log.warning(f"Post-auth sheet setup failed (non-fatal): {e}")
        Thread(target=_post_auth_setup_safe, daemon=True).start()
        log.info("[OAuth] Post-auth setup started in background")

        bridge_log("oauth_success", scopes=getattr(creds, "scopes", []))
        return {"status": "authenticated"}
    else:
        try:
            # request 'offline' to obtain a refresh token; include granted scopes to avoid prompting unnecessarily
            auth_url, _state = flow.authorization_url(
                prompt="consent",
                access_type="offline",
                include_granted_scopes="true"
            )
            # Cache PKCE code verifier
            if hasattr(flow, "code_verifier") and flow.code_verifier:
                with open("/tmp/oauth_verifier.txt", "w") as vf:
                    vf.write(flow.code_verifier)
        except Exception as e:
            log.error("Failed to build authorization URL", exc_info=True)
            raise HTTPException(500, f"authorization_url error: {e}")
        bridge_log("oauth_url_issued")
        return {
            "status": "needs_code",
            "message": "Visit the URL in a browser, authorize, and copy the code parameter from the redirected URL, then call this endpoint again with ?code=THE_CODE",
            "url": auth_url,
            "redirect_uri": REDIRECT_URI,
        }

@app.get("/auth")
def auth(request: Request,
         code: Optional[str] = Query(default=None, description="Authorization code from user"),
         state: Optional[str] = Query(default=None),
         error: Optional[str] = Query(default=None)):
    dyn_uri = get_dynamic_redirect_uri(request)
    return _auth_handler(code, state, error, dyn_uri)

# Provide a direct callback endpoint for OAuth2 redirect_uri
@app.api_route("/oauth2callback", methods=["GET", "HEAD"])
def oauth2callback(request: Request,
                   code: Optional[str] = Query(default=None),
                   state: Optional[str] = Query(default=None),
                   error: Optional[str] = Query(default=None)):
    """
    Optional direct callback endpoint. If the redirect_uri is pointed at the agent itself
    (e.g., via the CloudRunner proxy /agent/{id}/proxy/oauth2callback), complete the exchange here.
    """
    if request.method == "HEAD":
        return Response(status_code=204)
    if error:
        bridge_log("oauth_error", level="error", error=error, state=state)
        raise HTTPException(400, f"OAuth error: {error}")
    if not code:
        raise HTTPException(400, "Missing 'code' in callback")
    # Reuse the main handler to perform the exchange and setup
    dyn_uri = get_dynamic_redirect_uri(request)
    return _auth_handler(code, state, None, dyn_uri)

# Add POST helper endpoint for code exchange
from pydantic import BaseModel

class UpdateSheetLink(BaseModel):
    url: str

class UpdateGroupEmail(BaseModel):
    email: str

class ReminderConfig(BaseModel):
    subject: str
    body: str

class ReminderPayload(BaseModel):
    subject: Optional[str] = None
    body: Optional[str] = None

@app.post("/auth/code")
async def auth_code(request: Request):
    """Accept OAuth code via JSON, form, or query string for robustness."""
    code_val = None
    try:
        ctype = request.headers.get("content-type", "")
        if "application/json" in ctype:
            body = await request.json()
            if isinstance(body, dict):
                code_val = body.get("code")
        elif "application/x-www-form-urlencoded" in ctype:
            form = await request.form()
            code_val = form.get("code")
    except Exception as e:
        log.warning(f"/auth/code parse error: {e}")
    if not code_val:
        code_val = request.query_params.get("code")
    if not code_val:
        raise HTTPException(400, "Missing 'code'")
    dyn_uri = get_dynamic_redirect_uri(request)
    return _auth_handler(code_val, None, None, dyn_uri)


# --- Auth status & config endpoints ---

@app.get("/auth/status")
def auth_status():
    """Return whether the agent is authenticated with Google APIs.
    Also returns the sender domain type (common vs custom) so the
    frontend can warn users using personal gmail accounts.
    """
    global creds
    # Try to load creds from disk if not in memory
    if creds is None:
        for path in (SECRET_TOKEN_FILE, FALLBACK_TOKEN_FILE):
            try:
                if os.path.exists(path):
                    with open(path, "rb") as f:
                        creds_local = pickle.load(f)
                        creds = creds_local
                        break
            except Exception as e:
                log.warning(f"[auth_status] Failed loading creds from {path}: {e}")
    # Try refresh if expired
    try:
        if creds and getattr(creds, "expired", False) and getattr(creds, "refresh_token", None):
            creds.refresh(GoogleRequest())
            _safe_write_token(creds)
    except Exception as e:
        log.warning(f"[auth_status] Refresh failed: {e}")
    status = "authenticated" if (creds and getattr(creds, "valid", False)) else "needs_auth"
    scopes = list(getattr(creds, "scopes", []) or [])
    # Determine sender domain type for frontend warnings
    sender_email = ""
    domain_type  = "unknown"
    domain_warning = None
    if status == "authenticated":
        try:
            profile = get_sender_profile()
            sender_email = profile.get('emailAddress', '')
            if sender_email:
                if is_common_domain(sender_email):
                    domain_type    = "common"
                    domain_warning = (
                        f"You are using a personal email account ({sender_email}). "
                        "SPF/DKIM/DMARC cannot be configured for this domain, which "
                        "reduces email deliverability. For best results, connect a "
                        "Google Workspace account with a custom domain."
                    )
                else:
                    domain_type = "custom"
        except Exception as e:
            log.warning(f"[auth_status] Could not resolve sender profile: {e}")
    return {
        "status":         status,
        "scopes":         scopes,
        "redirect_uri":   REDIRECT_URI,
        "sender_email":   sender_email,
        "domain_type":    domain_type,
        "domain_warning": domain_warning,
        "daily_limit":    _get_daily_limit(sender_email) if sender_email else None,
        "emails_sent_today": _emails_sent_today,
    }

@app.get("/debug/oauth")
def debug_oauth():
    return {
        "redirect_uri": REDIRECT_URI,
        "credentials_file": CREDENTIALS_FILE,
        "credentials_file_exists": os.path.exists(CREDENTIALS_FILE),
        "token_secret_path": SECRET_TOKEN_FILE,
        "token_fallback_path": FALLBACK_TOKEN_FILE,
        "token_exists_secret": os.path.exists(SECRET_TOKEN_FILE),
        "token_exists_fallback": os.path.exists(FALLBACK_TOKEN_FILE),
    }

@app.get("/config/sheet")
def get_sheet_config():
    """Return current Google Sheet configuration (URL + derived ID)."""
    return {"sheet_url": SHEET_URL, "sheet_id": SHEET_ID}

@app.post("/config/sheet")
def set_sheet_config(link: UpdateSheetLink):
    """Update the Google Sheet URL/ID used by the agent at runtime."""
    global SHEET_URL, SHEET_ID
    SHEET_URL = link.url
    SHEET_ID = _sheet_id_from_url(SHEET_URL)
    # Best-effort: verify we can see or create the latest thread tab if already authenticated
    verified = False
    try:
        ensure_sheet(DEFAULT_TAB)
        verified = True
    except Exception as e:
        log.warning(f"[set_sheet_config] ensure_sheet failed (may be unauth'd yet): {e}")
    bridge_log("sheet_config_updated", sheet_url=SHEET_URL, sheet_id=SHEET_ID, verified=verified)
    return {"status": "ok", "sheet_url": SHEET_URL, "sheet_id": SHEET_ID, "verified": verified}

# --- Reminder config endpoints ---
@app.get("/config/reminder")
def get_reminder_config():
    """Return current default reminder subject/body."""
    return {"subject": REMINDER_SUBJECT, "body": REMINDER_BODY}

@app.post("/config/reminder")
def set_reminder_config(cfg: ReminderConfig):
    """Update the default reminder subject/body used by /manual/remind and the scheduler."""
    global REMINDER_SUBJECT, REMINDER_BODY
    REMINDER_SUBJECT = cfg.subject
    REMINDER_BODY = cfg.body
    bridge_log("reminder_config_updated")
    return {"status": "ok"}

@app.get("/manual/poll")
def manual_poll():
    bridge_log("manual_poll_triggered")
    poll_group_mail()
    return {"status": "polled"}

@app.get("/manual/remind")
def manual_remind():
    bridge_log("manual_remind_triggered")
    send_reminders()
    return {"status": "reminders sent"}


# POST endpoint to trigger reminders with custom subject/body
@app.post("/manual/remind")
def manual_remind_post(payload: ReminderPayload):
    bridge_log("manual_remind_triggered", subject=payload.subject, body_preview=(payload.body[:80] if payload.body else None))
    send_reminders(payload.subject, payload.body)
    return {"status": "reminders sent"}

# --- Unsubscribe endpoints (RFC 8058 / Google Feb 2024 mandate) ---------------

@app.get("/unsubscribe")
def unsubscribe(email: str = Query(..., description="Email address to unsubscribe")):
    """One-click unsubscribe via GET (linked from email footer)."""
    clean = email.lower().strip()
    _unsubscribed.add(clean)
    bridge_log("unsubscribe", email=clean)
    log.info(f"[unsubscribe] {clean} opted out.")
    return Response(
        content=f"""<!DOCTYPE html><html><body
          style="font-family:Arial,sans-serif;text-align:center;padding:60px;color:#333">
          <h2>&#x2705; Unsubscribed</h2>
          <p><strong>{clean}</strong> has been removed from future reminder emails.</p>
          <p style="color:#999;font-size:13px;">You can close this window.</p>
        </body></html>""",
        media_type="text/html"
    )

@app.post("/unsubscribe")
async def unsubscribe_post(request: Request):
    """POST one-click unsubscribe as required by List-Unsubscribe-Post header (RFC 8058)."""
    email_val = request.query_params.get("email", "")
    if not email_val:
        try:
            form = await request.form()
            email_val = form.get("email", "")
        except Exception:
            pass
    if not email_val:
        try:
            body_json = await request.json()
            email_val = body_json.get("email", "")
        except Exception:
            pass
    clean = email_val.lower().strip() if email_val else ""
    if clean:
        _unsubscribed.add(clean)
        bridge_log("unsubscribe_post", email=clean)
        log.info(f"[unsubscribe] POST opt-out: {clean}")
    return {"status": "unsubscribed", "email": clean}

@app.get("/unsubscribed/list")
def list_unsubscribed():
    """Admin endpoint — view all opt-out addresses for this agent session."""
    return {"unsubscribed": sorted(_unsubscribed), "count": len(_unsubscribed)}

# --- Revoke / reset endpoint --------------------------------------------------
@app.post("/revoke")
@app.get("/revoke")
def revoke_token():
    """
    Revoke the stored OAuth credentials (if any) **and** delete the local pickle.
    Works even after a restart when creds is None because it reloads the file.
    Always returns JSON {"status": "cleared"} so you can blindly call it.
    """
    global creds

    # 1. Load creds from disk if not in memory
    if creds is None:
        for path in (SECRET_TOKEN_FILE, FALLBACK_TOKEN_FILE):
            if os.path.exists(path):
                try:
                    with open(path, "rb") as f:
                        creds = pickle.load(f)
                    break
                except Exception as e:
                    log.warning(f"Could not load creds from {path}: {e}")

    # 2. Choose a token to revoke (prefer refresh_token → longer‑lived)
    token_to_revoke = None
    if creds:
        token_to_revoke = getattr(creds, "refresh_token", None) or getattr(creds, "token", None)

    if token_to_revoke:
        try:
            resp = requests.post(
                "https://oauth2.googleapis.com/revoke",
                params={"token": token_to_revoke},
                headers={"content-type": "application/x-www-form-urlencoded"},
                timeout=10,
            )
            if resp.status_code != 200:
                log.warning(f"Google revoke returned {resp.status_code}: {resp.text}")
        except Exception as e:
            log.warning(f"Token revoke request failed: {e}")

    # 3. Delete local token cache (try both secret and fallback; secret may be read-only so ignore failures)
    for path in (SECRET_TOKEN_FILE, FALLBACK_TOKEN_FILE):
        try:
            if os.path.exists(path):
                os.remove(path)
        except Exception as e:
            log.warning(f"Failed to delete token file at {path}: {e}")

    creds = None
    bridge_log("oauth_revoked")
    return {"status": "cleared"}
# ---------------- Scheduler ---------------- #

scheduler = BackgroundScheduler(timezone=TIME_ZONE)
scheduler.add_job(poll_group_mail, 'interval', minutes=1, id='poll_mail')
#scheduler.add_job(send_reminders, 'cron', hour='9,15', id='daily_reminder')  # 09:00 & 15:00 daily
scheduler.start()

@app.on_event("startup")
def startup_event():
    log.info("Agent started")
    bridge_log("startup")
    # Start the Cosmitude Bridge long-running loop in a background thread
    try:
        if not globals().get("_go_thread_started", False):
            Thread(target=go, daemon=True).start()
            globals()["_go_thread_started"] = True
            log.info("go() background thread started")
    except Exception as e:
        log.error(f"Failed to start go() thread: {e}", exc_info=True)
#------------------------------------------
#Login
#------------------------------------------

def login():
    try:
        global Sessionid
        global username
        global MobileNumber
        global forumID
        tempJson = {
        "MACAddress": 'Bridge-Web',
        "UserName":"${userName}",
        "Password":"${Password}",
        "ServerID":"${CAServerID}",
        }
        headers = {'Content-Type': 'application/json'}
        variab =json.dumps(tempJson)
        response = requests.post("${CAServerIP}" + 'loginForDevice', data=variab,headers=headers, timeout=600)
        strData = str(response.text)
        respJson = json.loads(strData)
        Sessionid = respJson['ErrorMessage']['SessionID']
        countryCode = MobileNumber = respJson['ErrorMessage']['CountryCode']
        MobileNumber = countryCode+respJson['ErrorMessage']['MobileNumber']
        bridge_log("agent_started")
        getForumDetails()
    except Exception as e:
        print (e)
        return e

#------------------------------------------
#Forum Details
#------------------------------------------ 
def getForumDetails():
    try:
        tempJson = {
        "MACAddress": 'Bridge-Web',
        "ForumID":forumID,
        "SessionID":Sessionid,
        "ServerID":'${CAServerID}',
        }
        headers = {'Content-Type': 'application/json'}
        variab =json.dumps(tempJson)
        response = requests.post('${CAServerIP}' + 'getRequestedForumDetails', data=variab,headers=headers, timeout=600)
        if response.status_code == 200:
            responseStr = str(response.text)
            respJson = json.loads(responseStr)
            errorCode = respJson['ErrorCode']
            if errorCode == 1172:
                errorMsg = respJson['ErrorMessage']
                forumDetails = errorMsg['ForumDataArray']
                for singleForum in forumDetails:
                    singleForumDetails = singleForum[forumID]
                    saveForumDetails = singleForumDetails['NewForumJsonData']
                    with open('Ca email tracking_${TemplateName}_Admin.txt', 'w') as f:
                        json.dump(saveForumDetails, f)

    except Exception as e:
        print (e)
        return e

#------------------------------------------
#Client Sync
#------------------------------------------

def clienntSync():
    try:
        clientSyncJson = {
        "SessionID":Sessionid,
        "MACAddress":'Bridge-Web',
        "ServerID":"${CAServerID}",
        "ServerName":'Bridge'
        }
        headers = {'Content-Type': 'application/json'}
        variab =json.dumps(clientSyncJson)
        response = requests.post('${CAServerIP}' + 'syncUserData', data=variab,headers=headers, timeout=600)
        strData = str(response.text)
        dataRead = json.loads(strData)
        print(dataRead['ErrorMessage'])
        syncData = dataRead['ErrorMessage']['Admin']
        if syncData:
            for data in syncData:
                if 'Bridge' in data:
                    bridgeData = data['Bridge']
                    flowName = bridgeData ['FlowID']
                    mNumber = bridgeData ['MobileNumber']
                    #<YOUR CODE STARTS HERE>
                    if flowName == "${TemplateName}_Trigger" and MobileNumber != mNumber:
                        bridge_log("flow_trigger", flow=flowName, mobile=mNumber)
                

                    #if flowName == "<FLOW NAME TO CHECK>":
                        #sendBridge(bridgeData,'<FLOW NAME TO REPLY>','<REPLY DATA>')
                        #sendWhisper(bridgeData,'<FLOW NAME TO REPLY>','<REPLY DATA>')
                        #dgeToSet(bridgeData,'<FLOW NAME TO REPLY>','<REPLY DATA>','<SET NAME>)
                        #generateReport(bridgeData,'<FLOW NAME TO REPLY>')
                        #sendSpecific(bridgeData,'<FLOW NAME TO REPLY>')
                    #<YOUR CODE ENDS HERE>
                elif 'UpdatedTemplateJson' in data:
                    templateForAdmin = data['UpdatedTemplateJson']
                    forumIDCheck = templateForAdmin['ForumID']
                    if forumIDCheck == forumID:
                        with open('Ca email tracking_${TemplateName}_Admin.txt', 'w') as f:
                            json.dump(templateForAdmin, f)
                        bridge_log("forum_details_cached")
    except Exception as e:
        print (e)

#------------------------------------------
#Send Bridge
#------------------------------------------

def sendBridge(bridgeData, replyFlow, replyData):
    try:
        TemplateID = "${TemplateId}"
        ForumID = "${forumID}"
#        current_dir_path = os.getcwd()
#        filePath = open(os.path.join(current_dir_path, 'Ca email tracking_${TemplateName}_Admin.txt'), 'r')
#        content = filePath.read()
#        jsonData = json.loads(content)
        FID = "${FID}"
        tempJson ={
        "ForumID": ForumID,
        "SessionID": Sessionid,
        "MACAddress": 'Bridge-Web',
        "Time": "6516516156161",
        "ScheduledDateTime": "now",
        "ScheduledBoolean": 0,
        "FlowID": replyFlow,
        "EnableChat": 1,
        "FlowType": "Custom",
        "BridgeForward": 0,
        "TemplateID": TemplateID,
        "TextCount": 1,
        "ImageCount": 1,
        "InvoiceID": "",
        "DocumentCount": 0,
        "User": True,
        "VideoCount": 0,
        "ReplyBridgeID": "",
        "HiddenFlow": False,
        "TempBridgeId": str(uuid.uuid4()),
        replyFlow: replyData,
        "FID": FID,
        "ServerID":"${CAServerID}",
        "SentTo":'0'
        }
        print (tempJson)
        variab = {"Data":json.dumps(tempJson)}
        up = {}
        response = requests.post('${CAServerIP}' + 'bridgeSendingToForum', files=up, data=variab, timeout=600)
        data = response.json()
        print (data)
    except Exception as e:
            print (e)
            return e

# ---------------- Run via uvicorn ---------------- #

if __name__ == "__main__":
    import uvicorn
    # Start go() in a background thread so the server can start
    try:
        if not globals().get("_go_thread_started", False):
            Thread(target=go, daemon=True).start()
            globals()["_go_thread_started"] = True
    except Exception as e:
        log.error(f"Failed to start go() thread in __main__: {e}", exc_info=True)
    uvicorn.run("gmail_group_monitor:app", host="0.0.0.0", port=8000)
    `}
`;
